import React, { useCallback } from "react";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const useResetUploader = () => {
  const {
    setRecipientEmail,
    uploaderCancelAll,
    setOpenUploader,
    setHideSubmit,
    setMailId,
  } = useUploader();
  const { closeModal } = useModal();

  const resetUploader = useCallback(() => {
    uploaderCancelAll();
    setRecipientEmail(null);
    setOpenUploader(false);
    window.scrollTo(0, 0);
    setHideSubmit(false);
    if (window.location.pathname.includes("uploading")) {
      setMailId(null);
    }
    closeModal();
    window.history.pushState(
      {},
      document.title,
      window.location.pathname.replace(/\/uploading\/.*/, "")
    );
  }, []);

  return resetUploader;
};

export default useResetUploader;
